import { OpenSheduleType } from "@/Appointments/Components/Scheduling/OpenScheduleTab";
import { SchedulerHelper } from "@/Appointments/Helpers/SchedulerHelper";
import { TemplateLight } from "@/Appointments/Models/Scheduling/TemplateLight";
import { WorkDayV2 } from "@/Appointments/Models/Scheduling/WorkDayV2";
import { SchedulingStore } from "@/Appointments/Stores/SchedulingStore";
import { SchedulingTabViews } from "@/Common/Models/UI/Enums";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";

class MainTemplateTabHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalOperations.TemplateTab.LoadLightTemplate, this.loadTemplateLight);
        this.RegisterOperation(LocalOperations.TemplateTab.LoadTemplateInfo, this.loadTemplateInfo);
        this.RegisterOperation(LocalOperations.TemplateTab.DeleteTemplate, this.deleteTemplate);
        this.RegisterOperation(LocalOperations.TemplateTab.SearchText, this.searchText);
        this.RegisterOperation(LocalOperations.TemplateTab.NewTemplateClick, this.newTemplateClick);
        this.RegisterOperation(LocalOperations.TemplateTab.ModifyClick, this.modifyClick);
        this.RegisterOperation(LocalOperations.TemplateTab.OpenIntervenorPopup, this.openIntervenorPopup);
        this.RegisterOperation(LocalOperations.TemplateTab.ModifyRuleSetClick, this.modifyRuleSetClick);
        this.RegisterOperation(LocalOperations.TemplateTab.OpenDeletePopup, this.openDeletePopup);
    }

    private loadTemplateLight(request: LocalEvent, store: SchedulingStore): void {
        store.schedulingAction.getTemplateLight(store.TemplateTabModel.get("SearchText"));
    }

    private loadTemplateInfo(request: LocalEvent, store: SchedulingStore): void {
        var item = request.Get<TemplateLight>("item");

        store.TemplateTabModel = store.TemplateTabModel.set("SelectedTemplateName", item.Name);
        store.TemplateTabModel = store.TemplateTabModel.set("SelectedTemplateId", item.Id);

        store.schedulingAction.getTemplateInfo(item.Id);
    }

    private deleteTemplate(request: LocalEvent, store: SchedulingStore): void {
        store.schedulingAction.deleteTemplate(store.TemplateTabModel.get("SelectedTemplateId"));

        store.TemplateTabModel = store.TemplateTabModel.set("DeletePopupOpen", false);
        sessionStore.hideGlobalOverlay();
    }

    private searchText(request: LocalEvent, store: SchedulingStore): void {
        store.TemplateTabModel = store.TemplateTabModel.set("SearchText", request.Get<string>("value"));
        store.schedulingAction.getTemplateLight(store.TemplateTabModel.get("SearchText"));
    }

    private newTemplateClick(request: LocalEvent, store: SchedulingStore): void {
        store.SchedulingTabModel = store.SchedulingTabModel.set("CurrentView", SchedulingTabViews.CreateTemplate);
        store.CreateTemplateTabModel = Immutable.fromJS(SchedulerHelper.getDefaultCreateTemplateTabModel());
    }

    private modifyClick(request: LocalEvent, store: SchedulingStore): void {
        store.SchedulingTabModel = store.SchedulingTabModel.set("CurrentView", SchedulingTabViews.CreateTemplate);

        store.CreateTemplateTabModel = store.CreateTemplateTabModel.set("Name", store.TemplateTabModel.get("SelectedTemplateName"));
        store.CreateTemplateTabModel = store.CreateTemplateTabModel.set("EditionTemplateId", store.TemplateTabModel.get("SelectedTemplateId"));

        var workDayArray = store.TemplateTabModel.get("SelectedTemplateWorkDay").toArray().map(u => {
            let workDayV2 = new WorkDayV2();
            workDayV2.calendarSlots = [...u.calendarSlots];
            workDayV2.HasRuleSet = u.HasRuleSet;
            workDayV2.date = u.date;
            workDayV2.EmployeeId = u.EmployeeId;
            return workDayV2;
        });

        store.CreateTemplateTabModel = store.CreateTemplateTabModel.set("WorkDayList", workDayArray.toImmutable());
        store.CreateTemplateTabModel = store.CreateTemplateTabModel.set("IsFromEdit", true);
    }

    private openIntervenorPopup(request: LocalEvent, store: SchedulingStore): void {
        store.TemplateTabModel = store.TemplateTabModel.set("OpenIntervenorPopup", !store.TemplateTabModel.get("OpenIntervenorPopup"));

        if (store.TemplateTabModel.get("OpenIntervenorPopup") === true) {
            sessionStore.showGlobalOverlay(true);
        }
        else {
            sessionStore.hideGlobalOverlay();
        }
    }

    private modifyRuleSetClick(request: LocalEvent, store: SchedulingStore): void {
        store.SchedulingTabModel = store.SchedulingTabModel.set("CurrentView", SchedulingTabViews.CreateTemplate);

        store.CreateTemplateTabModel = store.CreateTemplateTabModel.set("Name", store.TemplateTabModel.get("SelectedTemplateName"));
        store.CreateTemplateTabModel = store.CreateTemplateTabModel.set("EditionTemplateId", store.TemplateTabModel.get("SelectedTemplateId"));
        store.CreateTemplateTabModel = store.CreateTemplateTabModel.set("WorkDayList", store.TemplateTabModel.get("SelectedTemplateWorkDay"));
        store.CreateTemplateTabModel = store.CreateTemplateTabModel.set("IsFromEdit", true);
        store.CreateTemplateTabModel = store.CreateTemplateTabModel.set("CreateScheduleTypeCode", OpenSheduleType.RuleSet.toString());
    }

    private openDeletePopup(request: LocalEvent, store: SchedulingStore): void {
        store.TemplateTabModel = store.TemplateTabModel.set("DeletePopupOpen", !store.TemplateTabModel.get("DeletePopupOpen"));

        if (store.TemplateTabModel.get("DeletePopupOpen") === true)
            sessionStore.showGlobalOverlay(true);
        else
            sessionStore.hideGlobalOverlay();
    }
}

export { MainTemplateTabHandler };
